export const getErrorMessage = (err, defaultMsg) => {
    if (Array.isArray(err?.message)) {
        return err?.message[0]?.msg || defaultMsg
    }
    return (err?.response && err?.response?.data && err?.response?.data?.message) ||
        err?.message ||
        defaultMsg;

}